import GiftCard from "./GiftCard";

const GiftsGrid = ({ items }) => {
    return (
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3">
            {items.map((item) => (
                <GiftCard
                    key={item.id}
                    item={item}
                />
            ))}
        </div>
    );
};

export default GiftsGrid;
